import axios from 'axios'
import qs from 'qs'
import {apiRoot} from './config'
/**
 * @param  {Player} player
 *         The `Player` that this class should be attached to.
 *
 * @param  {String} url
 *         视频源地址
 * @param  {String} sid
 *         校区id
 * @param  {String} uid
 *         学生id
 */
class Transcode {
    constructor(player, url, sid, uid) {
        this.player = player;
        this.url = url.replace(/\s+/g, "");
        console.log(this)
        this.sid = sid;
        this.xid = uid
        this.init();
    }
    async init() {
        let m3u8 = this.isM3u8(this.url);
        let mp4 = this.isMp4(this.url);
        if (!this.isPad()) {
            if(mp4 && !m3u8 ) {
                const trueVideoData = await this.checkVideo();
                if (trueVideoData.data.idTranscode) {
                    this.initTranscodeVideo(trueVideoData)
                } else {
                    this.initCommonVideo(trueVideoData.data.url)
                }
            } else if(m3u8) {
                this.initCommonVideo(this.url)
            }
        } else {
            this.initCommonVideo(this.url)
        }
    }
    initTranscodeVideo(trueVideoData) {
        console.log({trueVideoData})
        let trueUrl = '';
        let trueVideoUrl = ''
        let routeNum = 0;
        trueVideoUrl = (window.location.protocol === 'https:' ? 'https:' : 'http:') + trueVideoData.data.cdn[routeNum] + trueVideoData.data.uri +  '_720.m3u8';
        trueUrl = this.getVideoSourceOption(trueVideoUrl);
        console.log(trueUrl);
        this.player.src(trueUrl);
        this.player.on('error', (err) => {
            console.log('资源加载失败：', {err});
            this.sendError(trueUrl.src);
            this.player.reset();
            
            if (routeNum < (trueVideoData.data.cdn.length -1)) {
                routeNum ++;
                trueVideoUrl= (window.location.protocol === 'https:' ? 'https:' : 'http:') + trueVideoData.data.cdn[routeNum] + trueVideoData.data.uri +  '_720.m3u8';
                trueUrl = this.getVideoSourceOption(trueVideoUrl);
                this.player.src(trueUrl)
            }

        })
    }
    initCommonVideo(url) {
        const trueUrl = this.getVideoSourceOption(url);
        this.player.src(trueUrl);
        this.player.on('error', (err) => {
            console.log('资源加载失败无资源可切换：', {err});
            this.sendError(trueUrl.src);
        })
    }
    checkVideo() {
        axios.create({
            baseURL: '/',
            timeout: 10000, // request timeout
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
        return new Promise(async (resolve, reject) => {
            axios({
                method: 'post',
                url: apiRoot + '/check_m3u8.php',
                data: qs.stringify({
                    u: this.url,
                    sid: this.sid
                })
            }).then(function (response) {
                console.log(response.data);
                if(response.data.code !== 200){
                    return Promise.reject(response.data)
                }
                resolve(response.data)
                return response.data;
            }).catch(function (error) {
                console.log(error);
            });
        })

    }
    isM3u8(url) {
        return /\.m3u8(#|\?|\.|$)/i.test(url)
    }
    isMp4(url) {
        return /\.mp4(#|\?|\.|$)/i.test(url)
    }
    getVideoSourceOption(url) {
        let sourceObj = {}
        if (this.isM3u8(url)) {
            sourceObj = {
                type: 'application/x-mpegURL'
            }
        } else {
            sourceObj = {
                type: 'video/mp4'
            }
        }

        return Object.assign({}, sourceObj, {
            src: url
        })
    }
    sendError(trueUrl) {
        axios.create({
            baseURL: '/',
            timeout: 10000, // request timeout
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
        return new Promise(async (resolve, reject) => {
            axios({
                method: 'post',
                url: apiRoot + '/send_netbreak.php',
                data: qs.stringify({
                    xid: this.xid,
                    sid: this.sid,
                    url: trueUrl
                })
            }).then(function (response) {
                console.log(response.data);
                if(response.data.code !== 200){
                    return Promise.reject(response.data)
                }
                resolve(response.data)
                return response.data;
            }).catch(function (error) {
                console.log(error);
            });
        })

    }
    isPad() {
        console.log(/(Android)/.test(navigator.userAgent))
        return /(Android)/.test(navigator.userAgent)
    }
}
export default Transcode